import React from 'react';
import NumberFormat from 'react-number-format';
import {setThousandSeparator, negativeNumberFormatting, isNullOrUndefined} from '../../../../../../../util/utils';
import Icon from '../../../../../BaseComponentWrappers/MotifIcon';
import Ellipse from '../../../../../EllipsesControl/EllipsesControl';

export const displayValue = (
	value,
	openModal = false,
	isDecimal = false,
	showArrow = false,
	suffix,
	decimalScale = 1,
	onDisplayAmountClick = {},
	showEllipses = true,
	isPrint = false,
	userPreferences,
	iconArrowUp,
	iconArrowDown
) => {
	let src, className;
	if (value || value === 0) {
		const preferencesJson = JSON.parse(userPreferences?.userPreferencesJson || '{}');
		const valFormatter = setThousandSeparator(userPreferences?.numberFormat);

		let formattedNumber = (
			<NumberFormat
				value={value}
				thousandSeparator={valFormatter.thousandSeparator}
				decimalSeparator={valFormatter.decimalSeparator}
				thousandsGroupStyle={valFormatter.thousandsGroupStyle}
				decimalScale={decimalScale}
				fixedDecimalScale={isDecimal}
				displayType="text"
				suffix={suffix ? suffix : ''}
				isNumericString
			/>
		);

		const negativenumberformat = !isNullOrUndefined(preferencesJson?.negativenumberformat)
			? preferencesJson?.negativenumberformat
			: 1;

		if (value < 0) {
			formattedNumber = negativeNumberFormatting(
				negativenumberformat,
				valFormatter,
				value,
				isDecimal,
				decimalScale,
				suffix
			);
		}

		if (showArrow && value !== 0 && value !== '0') {
			(src = value > 0 ? iconArrowUp : iconArrowDown), (className = value > 0 ? 'green-arrow' : 'red-arrow');
		}

		return (
			<section
				className={`DisplayAmount ${openModal ? 'showTxt' : ''} ${
					showArrow && isPrint ? (value > 0 ? 'amountGreen' : 'amountRed') : ''
				}`}
				onClick={openModal ? onDisplayAmountClick : undefined}
			>
				{showEllipses ? <Ellipse noOfLines={1} content={formattedNumber} tooltip={formattedNumber} /> : formattedNumber}
				{showArrow && value !== 0 && value !== '0' && !isPrint && <Icon src={src} className={className} />}
			</section>
		);
	} else {
		return <span className="noDataDash">{'-'}</span>;
	}
};
